var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095856(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "#007367"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6693 28L23.5026 26.7917L26.4609 23.8333H16.3359V22.1667H26.4609L23.5026 19.2083L24.6693 18L29.6693 23L24.6693 28Z",
    fill: "#007367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095856);
export default __webpack_public_path__ + "static/media/frame-48095856.7c545a6f5b05046eb3223bda300cb3c0.svg";
export { ForwardRef as ReactComponent };